import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/sys/speechTemplate/listByType',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/sys/speechTemplate/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/sys/speechTemplate/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/sys/speechTemplate/submit',
    method: 'post',
    data: row
  })
}
